import gameConfig from '../../assets/config';

import UbuntuBold from '../../assets/fonts/ubuntu/UBUNTU-B.TTF';
import UbuntuRegular from '../../assets/fonts/ubuntu/UBUNTU-R.TTF';
import { getAssetsScale } from 'Engine/utils/getAssetsScale';
import { soundsPreloaderConfig } from '../enums/eSounds';
import eAnimationTypes from '../enums/eAnimationTypes';
import flashlib from '../../assets/exported/game/FlashLib.json';
import gameSizeConfig from '../configs/gameSizeConfig';
// import assets from '../../assets/exported/game/FlashLibAssets';

const availableScales = ['0.7', '0.75', '0.8', '0.9'];
const scale = getAssetsScale({
  availableScales,
  safeWidthPortrait: gameSizeConfig.SAFE_WIDTH_PORTRAIT,
  safeHeightPortrait: gameSizeConfig.SAFE_HEIGHT_PORTRAIT,
  safeWidthLandscape: gameSizeConfig.SAFE_WIDTH_LANDSCAPE,
  safeHeightLandscape: gameSizeConfig.SAFE_HEIGHT_LANDSCAPE,
})

const assets = `flashlib/game/AssetsCombined1@${scale}x.json`;

export default {
  assets: [
    {name: 'GameAssets', path: assets, extension: 'json'},
    {name: 'GameFlashLib', path: flashlib, extension: 'json'},
    {name: 'gameConfig', path: gameConfig, extension: 'json'},
    {name: eAnimationTypes.SYMBOLS, path: 'animations/symbols/forest_treasures_symbols.json', extension: 'json',  options: { spineAtlasFile: `assets/animations/symbols/forest_treasures_symbols_${scale}x.atlas` } },

    // {name: eAnimationTypes.COINS, path: 'animations/coins/skeleton.json', extension: 'json'},
    {name: eAnimationTypes.JACKPOT_PANEL, path: 'animations/sweep_dwb/skeleton.json', extension: 'json', options: { spineAtlasFile: `assets/animations/sweep_dwb/skeleton_${scale}x.atlas` }},
    {name: 'BMFont', path: 'fonts/BMFont/BMFont.xml', extension: 'xml'},
  ],
  delayedAssets: [
    {name: eAnimationTypes.ANTISIPATOR, path: 'animations/antisipator/FT.anticipator.json', extension: 'json',  options: { spineAtlasFile: `assets/animations/antisipator/FT.anticipator_${scale}x.atlas` } },
    {name: eAnimationTypes.BIG_WIN, path: 'animations/bigWins/FT.bigwin.json', extension: 'json', options: { spineAtlasFile: `assets/animations/bigWins/FT.bigwin_${scale}x.atlas` }},
  ],
  fonts: [
    { name: 'UbuntuBold',
      path: UbuntuBold,
    },
    {
      name: 'UbuntuRegular',
      path: UbuntuRegular,
    },
  ],
  sounds: soundsPreloaderConfig
}
